import axios from 'axios';

// const API_URL = 'http://localhost:8887';
export const API_URL = process.env.REACT_APP_API_URL;

export const getAllDaten = () => axios.get(`${API_URL}/api//daten`);
export const getDatenById = (id) => axios.get(`${API_URL}/api/daten/${id}`);
